<div class="row" *ngIf="(checkCall | json) != '{}'">
    <div class="col-sm-12">
        <div class="row" *ngIf="viewType != 'tracking' && viewType != 'customs-exceptions'">
            <div class="col-sm-3">
                <label class="font-weight-bold">Load #</label>
            </div>
            <div class="col-sm-9">
                <select name="quoteOrderLineID" [(ngModel)]="checkCall.quoteOrderLineId" class="form-select" required>
                    <option *ngFor="let line of quoteOrderLineList" value="{{line.quoteOrderLineID}}">{{line.legNumber}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Event</label>
            </div>
            <div class="col-sm-9">
                <select name="eventCode" [(ngModel)]="checkCall.orderEventTypeID" class="form-select" required>
                    <option *ngFor="let eventType of orderEventTypeList" value="{{eventType.orderEventTypeID}}">{{eventType.code}} - {{eventType.reportDescription}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Last Update</label>
            </div>
            <div class="col-sm-9">
                <kendo-datepicker style="width: 150px; margin: 2px;" [(ngModel)]="checkCall.dateOfCall"></kendo-datepicker>
                <kendo-timepicker style="width: 150px; margin: 2px;" [(ngModel)]="checkCall.dateOfCall" [format]="'HH:mm'"></kendo-timepicker>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Location</label>
            </div>
            <div class="col-sm-9">
                <city-dropdown [parentForm]="checkCallForm" [ctrlName]="'cityControl'" [placeholder]="'Enter a City'" [isCityStateZip]="true" [defaultCity]="defaultCheckCallCity" [isRequired]="true"></city-dropdown>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Check Call Notes</label>
            </div>
            <div class="col-sm-9">
                <textarea class="form-control" [(ngModel)]="checkCall.checkCallNote"></textarea>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 m-2">
            <button class="btn btn-primary m-2" (click)="save()">Save</button>
            <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
        </div>
    </div>
</div>
